import React, { useEffect, useState } from "react"; 
import en from './locales/en'
import tr from './locales/tr'
import de from './locales/de'

  function Translator() {
    const [locale, setLocale] = useState("/")

    useEffect(() => {
        let locale = window.location.pathname;
        setLocale(locale)
    })

    switch (locale) {
      case "/en": return en; break;
      case "/de": return de; break;
      case "/tr": return tr; break;
      case "/": return tr; break;
      default: return en; break;
    }
 

}

export default Translator;